export default function Button({
    children,
    variant = "primary", // primary | secondary | ghost | danger
    size = "md",         // sm | md
    disabled = false,
    className = "",
    ...props
  }) {
    const base =
      "inline-flex items-center justify-center rounded-xl font-medium transition " +
      "focus:outline-none focus:ring-2 focus:ring-offset-2";
  
    const variants = {
      primary: "bg-birdie-green text-white hover:bg-birdie-green-dark focus:ring-birdie-mustard/40",
      secondary: "border border-birdie-green/15 bg-white text-birdie-charcoal hover:bg-birdie-beige focus:ring-birdie-mustard/40",
      ghost: "text-birdie-charcoal hover:bg-birdie-beige focus:ring-birdie-mustard/40",
      danger: "bg-red-600 text-white hover:bg-red-700 focus:ring-red-600",
    };
  
    const sizes = {
      sm: "px-3 py-2 text-sm",
      md: "px-4 py-2 text-sm",
    };
  
    return (
      <button
        disabled={disabled}
        className={`${base} ${variants[variant]} ${sizes[size]} ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  }
  